import { createAction } from 'redux-actions';
import * as actionTypes from '../constants';

export const createTicket = createAction(actionTypes.CREATE_TICKET);
export const createTicketSuccess = createAction(actionTypes.CREATE_TICKET_SUCCESS);
export const createTicketFailure = createAction(actionTypes.CREATE_TICKET_FAILURE);

export const saveTicket = createAction(actionTypes.SAVE_TICKET);
export const saveTicketSuccess = createAction(actionTypes.SAVE_TICKET_SUCCESS);
export const saveTicketFailure = createAction(actionTypes.SAVE_TICKET_FAILURE);
export const resetTicketSuccess = createAction(actionTypes.RESET_TICKET_SUCCESS);

export const addComment = createAction(actionTypes.ADD_COMMENT);
export const addCommentSuccess = createAction(actionTypes.ADD_COMMENT_SUCCESS);
export const addCommentFailure = createAction(actionTypes.ADD_COMMENT_FAILURE);

export const getTicket = createAction(actionTypes.GET_TICKET);
export const getTicketSuccess = createAction(actionTypes.GET_TICKET_SUCCESS);
export const getTicketFailure = createAction(actionTypes.GET_TICKET_FAILURE);

export const getTicketActionTypes = createAction(actionTypes.GET_TICKET_ACTION_TYPES);
export const getTicketActionTypesSuccess = createAction(
  actionTypes.GET_TICKET_ACTION_TYPES_SUCCESS,
);
export const getTicketActionTypesFailure = createAction(
  actionTypes.GET_TICKET_ACTION_TYPES_FAILURE,
);
export const getCategoryInfo = createAction(actionTypes.GET_CATEGORY_INFO);
export const getCategoryInfoSuccess = createAction(actionTypes.GET_CATEGORY_INFO_SUCCESS);
export const getCategoryInfoFailure = createAction(actionTypes.GET_CATEGORY_INFO_FAILURE);

export const getCommentsByTicketId = createAction(actionTypes.GET_COMMENTS_BY_TICKET_ID);
export const getCommentsByTicketIdSuccess = createAction(
  actionTypes.GET_COMMENTS_BY_TICKET_ID_SUCCESS,
);
export const getCommentsByTicketIdFailure = createAction(
  actionTypes.GET_COMMENTS_BY_TICKET_ID_FAILURE,
);

export const getTicketStatus = createAction(actionTypes.GET_TICKET_STATUS);
export const getTicketStatusSuccess = createAction(actionTypes.GET_TICKET_STATUS_SUCCESS);
export const getTicketStatusFailure = createAction(actionTypes.GET_TICKET_STATUS_FAILURE);

export const snoozeTicketRequest = createAction(actionTypes.SNOOZE_TICKET_REQUEST);
export const snoozeTicketSuccess = createAction(actionTypes.SNOOZE_TICKET_SUCCESS);
export const snoozeTicketFailure = createAction(actionTypes.SNOOZE_TICKET_FAILURE);
